// sway

export const Templates_CRUD = (msp_id: string) => `/api/sway/msp/${msp_id}/template`;
